import React from 'react';
import { colors } from '../constants';

const DataTable = ({ width, color }) => (
  <svg
    width={width}
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 7.25V5L6.75 5V7.25H3.5ZM8.25 7.25V5H16.5V7.25H8.25ZM3.5 8.75H6.75V11.25H3.5V8.75ZM2 12.75V11.25V8.75V7.25V4C2 3.72386 2.22386 3.5 2.5 3.5H17.5C17.7761 3.5 18 3.72386 18 4V16C18 16.2761 17.7761 16.5 17.5 16.5H2.5C2.22386 16.5 2 16.2761 2 16V12.75ZM3.5 12.75H6.75V15H3.5V12.75ZM8.25 12.75V15H16.5V12.75H8.25ZM16.5 11.25V8.75H8.25V11.25H16.5Z"
      fill={color}
    />
  </svg>
);

DataTable.defaultProps = {
  width: 20,
  color: colors.mediumBlue,
};

export default DataTable;
